// Pre-scripts bundle — mirrors gulp "prescripts" task
var helpers = (function () {
  var $ = jQuery;
  var _translationRegexMemo;
  var _helpers = {};

  _helpers.countryInfo = {
    AU: {
      countryAbbr: "AU",
      countryAbbrFixedTwo: "AU",
      countryNameLong: "Australia",
      countryNameShort: "Australia",
      countryNameAdj: "Australian",
      countryPrimaryTZ: "Australia/Sydney",
      countryUrl: "https://www.thryv.com.au",
    },
    US: {
      countryAbbr: "US",
      countryAbbrFixedTwo: "US",
      countryNameLong: "the United States",
      countryNameShort: "United States",
      countryNameAdj: "United States",
      countryPrimaryTZ: "America/Chicago",
      countryUrl: "https://www.thryv.com",
    },
    CA: {
      countryAbbr: "CA",
      countryAbbrFixedTwo: "CA",
      countryNameLong: "Canada",
      countryNameShort: "Canada",
      countryNameAdj: "Canadian",
      countryPrimaryTZ: "America/Winnipeg",
      countryUrl: "https://www.thryv.ca",
    },
    NZ: {
      countryAbbr: "NZ",
      countryAbbrFixedTwo: "NZ",
      countryNameLong: "New Zealand",
      countryNameShort: "New Zealand",
      countryNameAdj: "New Zealand",
      countryPrimaryTZ: "NZ",
      countryUrl: "https://www.thryv.co.nz",
    },
  };

  _helpers.guessedCountry = (function () {
    // var canArr = moment.tz.zonesForCountry("CA");
    // if (moment.tz.guess().indexOf("Australia") != -1) {
    //   _helpers.countryInfo.guessedCountryAbbr;
    // }

    var guessedCountry =
      window.thryvData && thryvData.geoip && thryvData.geoip.country
        ? thryvData.geoip.country
        : "US";

    if (!guessedCountry) {
      guessedCountry = "US";
    } else if (guessedCountry === "AU") {
      guessedCountry = "AU";
    } else if (guessedCountry === "CA") {
      guessedCountry = "CA";
    }

    return guessedCountry;
  })();

  _helpers.checkinputVal = function (inputVal, elem) {
    if (inputVal == "") return;
    if (inputVal.match(".[0-9]{3}.[0-9]{3}-[0-9]{4}") == null) {
      if (inputVal.match("[0-9]{10}") != null) {
        formatinputVal(inputVal, elem);
      }
    }
  };

  _helpers.formatPhoneVal = function (
    inputVal,
    elem,
    country = thryvSettings.thryvCountry,
  ) {
    var phone = new String(inputVal);
    elem = $(elem);
    if (country === "AU" || country === "AU") {
      phone = phone.substring(0, 12);
      if (phone.match("[0-9]{4}.[0-9]{3}.[0-9]{3}") == null) {
        var i;
        var phoneNumeric = (phoneChar = "");
        for (i = 0; i < phone.length; i++) {
          // Go thru what user has entered one character at a time.
          var phoneChar = phone.substr(i, 1);
          if (!isNaN(phoneChar) && phoneChar != " ")
            phoneNumeric = phoneNumeric + phoneChar;
        }
        phone = "";
        for (i = 0; i < phoneNumeric.length; i++) {
          // If you are on the 4th digit, put ') ' before that.
          if (i == 4) phone = phone + " ";
          // If you are on the 7th digit, insert '-' before that.
          if (i == 7) phone = phone + " ";
          // Add the digit to the phone charatcer string you are building.
          phone = phone + phoneNumeric.substr(i, 1);
        }
      } else {
        // console.log("test");
        phone =
          phone.substring(0, 4) +
          " " +
          phone.substring(5, 8) +
          " " +
          phone.substring(9, 13);
      }
      if (phone != inputVal) inputVal = phone;
      elem.val(inputVal);
    } else if (country === "NZ") {
      phone = phone.substring(0, 13);
      let areaCodes = ["020", "021", "022", "027"];

      if (
        areaCodes.includes(phone.substring(0, 3)) &&
        phone.match("[0-9]{3}.[0-9]{3}.[0-9]{4,5}") == null
      ) {
        var i;
        var phoneNumeric = (phoneChar = "");
        for (i = 0; i < phone.length; i++) {
          // Go thru what user has entered one character at a time.
          var phoneChar = phone.substr(i, 1);
          if (!isNaN(phoneChar) && phoneChar != " ")
            phoneNumeric = phoneNumeric + phoneChar;
        }
        phone = "";
        for (i = 0; i < phoneNumeric.length; i++) {
          // If you are on the 4th digit, put ') ' before that.
          if (i == 3) phone = phone + " ";
          // If you are on the 7th digit, insert '-' before that.
          if (i == 6) phone = phone + " ";
          // Add the digit to the phone charatcer string you are building.
          phone = phone + phoneNumeric.substr(i, 1);
        }
      } else if (phone.match("[0-9]{4}.[0-9]{3}.[0-9]{3}") == null) {
        var i;
        var phoneNumeric = (phoneChar = "");
        for (i = 0; i < phone.length; i++) {
          // Go thru what user has entered one character at a time.
          var phoneChar = phone.substr(i, 1);
          if (!isNaN(phoneChar) && phoneChar != " ")
            phoneNumeric = phoneNumeric + phoneChar;
        }
        phone = "";
        for (i = 0; i < phoneNumeric.length; i++) {
          // If you are on the 4th digit, put ') ' before that.
          if (i == 4) phone = phone + " ";
          // If you are on the 7th digit, insert '-' before that.
          if (i == 7) phone = phone + " ";
          // Add the digit to the phone charatcer string you are building.
          phone = phone + phoneNumeric.substr(i, 1);
        }
      } else {
        phone = areaCodes.includes(phone.substring(0, 3))
          ? phone.substring(0, 3) +
            " " +
            phone.substring(4, 9) +
            " " +
            phone.substring(8, 14)
          : phone.substring(0, 4) +
            " " +
            phone.substring(5, 8) +
            " " +
            phone.substring(9, 13);
      }
      if (phone != inputVal) inputVal = phone;
      elem.val(inputVal);
    } else {
      phone = phone.substring(0, 14);
      if (phone.match(".[0-9]{3}.[0-9]{3}-[0-9]{4}") == null) {
        if (
          phone.match(
            ".[0-9]{2}.[0-9]{3}-[0-9]{4}|" +
              ".[0-9].[0-9]{3}-[0-9]{4}|" +
              ".[0-9]{3}.[0-9]{2}-[0-9]{4}|" +
              ".[0-9]{3}.[0-9]-[0-9]{4}",
          ) == null
        ) {
          var i;
          var phoneNumeric = (phoneChar = "");
          // Loop thru what user has entered.
          for (i = 0; i < phone.length; i++) {
            // Go thru what user has entered one character at a time.
            var phoneChar = phone.substr(i, 1);
            if (!isNaN(phoneChar) && phoneChar != " ")
              phoneNumeric = phoneNumeric + phoneChar;
          }
          phone = "";
          for (i = 0; i < phoneNumeric.length; i++) {
            // If it's the first digit, throw in '(' before that.
            if (i == 0) phone = phone + "(";
            // If you are on the 4th digit, put ') ' before that.
            if (i == 3) phone = phone + ") ";
            // If you are on the 7th digit, insert '-' before that.
            if (i == 6) phone = phone + "-";
            // Add the digit to the phone charatcer string you are building.
            phone = phone + phoneNumeric.substr(i, 1);
          }
        }
      } else {
        // This means the tel no is in proper format. Make sure by replacing the 0th, 4th and 8th character.
        phone =
          "(" +
          phone.substring(1, 4) +
          ") " +
          phone.substring(5, 8) +
          "-" +
          phone.substring(9, 13);
      }
      // So far you are working internally. Refresh the screen with the re-formatted value.
      if (phone != inputVal) {
        inputVal = phone;
        elem.val(inputVal);
        console.info("elemVal: " + elem.val());
      }
    }
  };

  _helpers.formatPhone = function (
    inputVal,
    country = thryvSettings.thryvCountry,
  ) {
    var phone = new String(inputVal);
    if (country === "AU" || country === "AU") {
      phone = phone.substring(0, 12);
      if (phone.match("[0-9]{4}.[0-9]{3}.[0-9]{3}") == null) {
        var i;
        var phoneNumeric = (phoneChar = "");
        for (i = 0; i < phone.length; i++) {
          // Go thru what user has entered one character at a time.
          var phoneChar = phone.substr(i, 1);
          if (!isNaN(phoneChar) && phoneChar != " ")
            phoneNumeric = phoneNumeric + phoneChar;
        }
        phone = "";
        for (i = 0; i < phoneNumeric.length; i++) {
          // If you are on the 4th digit, put ') ' before that.
          if (i == 4) phone = phone + " ";
          // If you are on the 7th digit, insert '-' before that.
          if (i == 7) phone = phone + " ";
          // Add the digit to the phone charatcer string you are building.
          phone = phone + phoneNumeric.substr(i, 1);
        }
      } else {
        // console.log("test");
        phone =
          phone.substring(0, 4) +
          " " +
          phone.substring(5, 8) +
          " " +
          phone.substring(9, 13);
      }
      if (phone != inputVal) inputVal = phone;
    } else if (country === "NZ") {
      phone = phone.substring(0, 13);
      let areaCodes = ["020", "021", "022", "027"];

      if (
        areaCodes.includes(phone.substring(0, 3)) &&
        phone.match("[0-9]{3}.[0-9]{3}.[0-9]{4,5}") == null
      ) {
        var i;
        var phoneNumeric = (phoneChar = "");
        for (i = 0; i < phone.length; i++) {
          // Go thru what user has entered one character at a time.
          var phoneChar = phone.substr(i, 1);
          if (!isNaN(phoneChar) && phoneChar != " ")
            phoneNumeric = phoneNumeric + phoneChar;
        }
        phone = "";
        for (i = 0; i < phoneNumeric.length; i++) {
          // If you are on the 4th digit, put ') ' before that.
          if (i == 3) phone = phone + " ";
          // If you are on the 7th digit, insert '-' before that.
          if (i == 6) phone = phone + " ";
          // Add the digit to the phone charatcer string you are building.
          phone = phone + phoneNumeric.substr(i, 1);
        }
      } else if (phone.match("[0-9]{4}.[0-9]{3}.[0-9]{3}") == null) {
        var i;
        var phoneNumeric = (phoneChar = "");
        for (i = 0; i < phone.length; i++) {
          // Go thru what user has entered one character at a time.
          var phoneChar = phone.substr(i, 1);
          if (!isNaN(phoneChar) && phoneChar != " ")
            phoneNumeric = phoneNumeric + phoneChar;
        }
        phone = "";
        for (i = 0; i < phoneNumeric.length; i++) {
          // If you are on the 4th digit, put ') ' before that.
          if (i == 4) phone = phone + " ";
          // If you are on the 7th digit, insert '-' before that.
          if (i == 7) phone = phone + " ";
          // Add the digit to the phone charatcer string you are building.
          phone = phone + phoneNumeric.substr(i, 1);
        }
      } else {
        phone = areaCodes.includes(phone.substring(0, 3))
          ? phone.substring(0, 3) +
            " " +
            phone.substring(4, 9) +
            " " +
            phone.substring(8, 14)
          : phone.substring(0, 4) +
            " " +
            phone.substring(5, 8) +
            " " +
            phone.substring(9, 13);
      }
      if (phone != inputVal) inputVal = phone;
    } else {
      phone = phone.substring(0, 14);
      if (phone.match(".[0-9]{3}.[0-9]{3}-[0-9]{4}") == null) {
        if (
          phone.match(
            ".[0-9]{2}.[0-9]{3}-[0-9]{4}|" +
              ".[0-9].[0-9]{3}-[0-9]{4}|" +
              ".[0-9]{3}.[0-9]{2}-[0-9]{4}|" +
              ".[0-9]{3}.[0-9]-[0-9]{4}",
          ) == null
        ) {
          var i;
          var phoneNumeric = (phoneChar = "");
          // Loop thru what user has entered.
          for (i = 0; i < phone.length; i++) {
            // Go thru what user has entered one character at a time.
            var phoneChar = phone.substr(i, 1);
            if (!isNaN(phoneChar) && phoneChar != " ")
              phoneNumeric = phoneNumeric + phoneChar;
          }
          phone = "";
          for (i = 0; i < phoneNumeric.length; i++) {
            // If it's the first digit, throw in '(' before that.
            if (i == 0) phone = phone + "(";
            // If you are on the 4th digit, put ') ' before that.
            if (i == 3) phone = phone + ") ";
            // If you are on the 7th digit, insert '-' before that.
            if (i == 6) phone = phone + "-";
            // Add the digit to the phone charatcer string you are building.
            phone = phone + phoneNumeric.substr(i, 1);
          }
        }
      } else {
        // This means the tel no is in proper format. Make sure by replacing the 0th, 4th and 8th character.
        phone =
          "(" +
          phone.substring(1, 4) +
          ") " +
          phone.substring(5, 8) +
          "-" +
          phone.substring(9, 13);
      }
      // So far you are working internally. Refresh the screen with the re-formatted value.
      if (phone != inputVal) inputVal = phone;
    }
    return phone;
  };

  _helpers.verifyPhoneNumber = function (inputName, callback) {
    // set endpoint and your access key
    var status;
    var access_key = "f3aae8e12b69e0e264b8fefa4b00e4d0";
    var phone_number = $("input[name='" + inputName + "']")
      .val()
      .replace(/[^0-9]/g, "");
    var numVerifyUrl =
      "https://apilayer.net/api/validate?access_key=" +
      access_key +
      "&number=" +
      phone_number +
      "&country_code=" +
      thryvSettings.thryvCountry;

    $.ajax({
      url: numVerifyUrl,
      dataType: "jsonp",
      async: false,
      success: function (data) {
        status = data.valid;
      },
      error: function () {
        status = false;
      },
      complete: function () {
        callback(status);
      },
    });
  };

  /**
   * Get query parameter from URL
   * @param  {String} strQStrParam Name of the param
   * @return {Mixed}
   */
  _helpers.getQueryStringParamValue = function (strQStrParam) {
    // When the page is embedded in a cross-origin iframe (e.g. a customer
    // site iframing our legal pages), reading parent.location.href throws
    // SecurityError. Fall back to our own URL — query params on the embedded
    // page itself are still useful, and we never have a legitimate need to
    // read a foreign parent's URL.
    var strURL;
    try {
      strURL = window.parent.window.parent.location.href;
    } catch (e) {
      strURL = window.location.href;
    }
    var strQStrParamValue = "";
    if (strURL.indexOf("?") != -1) {
      strQStrParamValue = strURL.substr(strURL.indexOf("?") + 1);

      if (strQStrParamValue.indexOf(strQStrParam) != -1) {
        strQStrParamValue = strQStrParamValue.substr(
          strQStrParamValue.indexOf(strQStrParam),
        );
        strQStrParamValue = strQStrParamValue.substr(
          strQStrParamValue.indexOf("=") + 1,
        );
        if (strQStrParamValue.indexOf("&") != -1)
          strQStrParamValue = strQStrParamValue.substr(
            0,
            strQStrParamValue.indexOf("&"),
          );
        return strQStrParamValue;
      } else {
        strQStrParamValue = "";
        return strQStrParamValue;
      }
    } else {
      strQStrParamValue = "";
      return strQStrParamValue;
    }
  };

  // Get, check, and set cookies for utm params
  _helpers.setThryvCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  };

  /**
   * Copy element text to clipboard
   * @param  {Object} elem DOM Element
   * @return {Void}
   */
  _helpers.copyToClipBoard = function (elem) {
    elem.select();
    elem.setSelectionRange(0, 99999);
    document.execCommand("copy");
  };

  /**
   * Check if an email is valid or not
   * @param  {String} email Email address
   * @return {Boolean}
   */
  _helpers.validateEmail = function (email) {
    var regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return regex.test(String(email).toLowerCase());
  };

  /**
   * Cookie helper object to get/set/remove cookies.
   * @type {Object}
   */
  _helpers.Cookie = {};

  /**
   * Set cookie
   * @param {string}          name  Name of the cookie
   * @param {Mixed}           value Value of the cookie
   * @param {Boolean|Integer} days  Number of days or session cookie if false
   * @param {String}          path  Path of the cookie
   * @return {Void}
   */
  _helpers.Cookie.set = function (name, value, days = false, path = "/") {
    var expires;

    if (days) {
      var date = new Date();

      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    } else {
      // session only cookie

      expires = "";
    }

    document.cookie = name + "=" + value + expires + "; path=" + path;
  };

  /**
   * Get cookie or all cookies
   * @param  {Boolean|String} name name of the cookie or false to get all cookie
   * @return {String|object}
   */
  _helpers.Cookie.get = function (name = false) {
    if (document.cookie.length > 0) {
      if (name) {
        var c_start, c_end;
        c_start = document.cookie.indexOf(name + "=");

        if (c_start != -1) {
          c_start = c_start + name.length + 1;
          var c_end = document.cookie.indexOf(";", c_start);

          if (c_end == -1) {
            c_end = document.cookie.length;
          }

          return unescape(document.cookie.substring(c_start, c_end));
        }
      } else {
        // get all cookies

        var pairs = document.cookie.split(";");
        var cookies = {};

        for (var i = 0; i < pairs.length; i++) {
          var pair = pairs[i].split("=");
          cookies[(pair[0] + "").trim()] = unescape(pair.slice(1).join("="));
        }

        return cookies;
      }
    }

    return null;
  };

  /**
   * Remove a cookie
   * @param  {String} name Name of the cookie
   * @param  {String} path Path of the cookie
   * @return {Void}
   */
  _helpers.Cookie.remove = function (name, path = "/") {
    this.set(name, "", -1, path);
  };

  /**
   * Alternative implementation of setTimeout function
   * @param  {Integer} milliseconds
   * @return {void}
   */
  _helpers.syncDelay = function (milliseconds) {
    var start = new Date().getTime();
    var end = 0;

    while (end - start < milliseconds) {
      end = new Date().getTime();
    }
  };

  _helpers.objectToQueryString = function (obj, prefix) {
    var str = [],
      k,
      v;
    for (var p in obj) {
      if (!obj.hasOwnProperty(p)) {
        continue;
      } // skip things from the prototype
      if (~p.indexOf("[")) {
        k = prefix
          ? prefix +
            "[" +
            p.substring(0, p.indexOf("[")) +
            "]" +
            p.substring(p.indexOf("["))
          : p;
        // only put whatever is before the bracket into new brackets; append the rest
      } else {
        k = prefix ? prefix + "[" + p + "]" : p;
      }
      v = obj[p];
      str.push(
        typeof v == "object"
          ? _helpers.objectToQueryString(v, k)
          : encodeURIComponent(k) + "=" + encodeURIComponent(v),
      );
    }
    return str.join("&");
  };

  _helpers.isJSON = function (input) {
    if (input == null || input == undefined || input == "undefined")
      return false;
    return JSON.stringify(input).includes("{") &&
      JSON.stringify(input).includes("}")
      ? true
      : false;
  };

  _helpers.capitalize = function (word) {
    const words = word.split(" ");

    for (let i = 0; i < words.length; i++) {
      if (/[a-zA-Z]/.test(words[i])) {
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
      }
    }

    return words.join(" ");
  };

  _helpers.formatZip = function (postalCode, country) {
    if (postalCode != null) {
      // check for US ZIP code
      if (country == "US") {
        return postalCode.replace(/[^0-9.]{0,5}/g, "");
      } else if (country == "AU" || country == "AU") {
        return postalCode.replace(/[^0-9.]{0,4}/g, "");
      } else if (country == "CA" || country == "CA") {
        postalCode = postalCode.toUpperCase();
        return (
          postalCode.charAt(0).replace(/[^A-Z.]/g, "") +
          postalCode.charAt(1).replace(/[^0-9.]/g, "") +
          postalCode.charAt(2).replace(/[^A-Z.]/g, "") +
          postalCode.charAt(3).replace(/[^*]/g, " ") +
          postalCode.charAt(4).replace(/[^0-9.]/g, "") +
          postalCode.charAt(5).replace(/[^A-Z.]/g, "") +
          postalCode.charAt(6).replace(/[^0-9.]/g, "")
        );
      }
    }
  };

  _helpers.millisToMinutesAndSeconds = function (millis) {
    var minutes = Math.floor(millis / 60000);
    var seconds = ((millis % 60000) / 1000).toFixed(0);
    return seconds == 60
      ? minutes + 1 + ":00"
      : minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
  };

  _helpers.numOnly = function (n, allowDecimal = false, max = false) {
    var num =
      max != false && n > max
        ? typeof max == "number"
          ? max.toString()
          : max
        : n;
    // format number
    if (allowDecimal == false) {
      return num.replace(/[^0-9]/g, "");
    } else {
      var format_num = num.replace(/[^0-9.]/g, ""),
        num_split = format_num.split("."),
        before_dec = num_split[0],
        after_dec =
          typeof num_split[1] !== "undefined"
            ? num_split[1].slice(0, 2).length < 2
              ? "." + num_split[1].slice(0, 2) + "0"
              : "." + num_split[1].slice(0, 2)
            : "";
      return before_dec + after_dec;
    }
  };

  _helpers.formatNumber = function (n) {
    // format number 1000000 to 1,234,567
    return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  _helpers.formatPercentage = function (input) {
    var num = input.val();
    var format_num = num.replace(/[^0-9.]/g, ""),
      num_split = format_num.split("."),
      before_dec = num_split[0],
      after_dec = typeof num_split[1] !== "undefined" ? "." + num_split[1] : "";
    input.val(before_dec + after_dec + "%");
  };

  _helpers.formatCurr = function (n) {
    n = typeof n !== "string" ? n.toString() : n;
    var format_num = n.replace(/[^0-9.]/g, ""),
      num_split = format_num.replace(".00", "").split("."),
      before_dec = num_split[0],
      after_dec =
        typeof num_split[1] !== "undefined"
          ? num_split[1].length > 2
            ? "." + num_split[1].slice(0, 2)
            : "." + num_split[1]
          : "";

    return parseFloat(before_dec).toLocaleString("en-US") + after_dec;
  };

  _helpers.formatCurrency = function (input, blur) {
    // appends $ to value, validates decimal side
    // and puts cursor back in right position.

    // get input value
    var input_val = input.val();

    // don't validate empty input
    if (input_val === "") {
      return;
    }

    // original length
    var original_len = input_val.length;

    // initial caret position
    var caret_pos = input.prop("selectionStart");

    // check for decimal
    if (input_val.indexOf(".") >= 0) {
      // get position of first decimal
      // this prevents multiple decimals from
      // being entered
      var decimal_pos = input_val.indexOf(".");

      // split number by decimal point
      var left_side = input_val.substring(0, decimal_pos);
      var right_side = input_val.substring(decimal_pos);

      // add commas to left side of number
      left_side = _helpers.formatNumber(left_side);

      // validate right side
      right_side = _helpers.formatNumber(right_side);

      // On blur make sure 2 numbers after decimal
      if (blur === "blur") {
        right_side += "00";
      }

      // Limit decimal to only 2 digits
      right_side = right_side.substring(0, 2);

      // join number by .
      input_val = "$" + left_side + "." + right_side;
    } else {
      // no decimal entered
      // add commas to number
      // remove all non-digits
      input_val = _helpers.formatNumber(input_val);
      input_val = "$" + input_val;

      // final formatting
      if (blur === "blur") {
        input_val += ".00";
      }
    }

    // send updated string to input
    input.val(input_val);

    // put caret back in the right position
    var updated_len = input_val.length;
    caret_pos = updated_len - original_len + caret_pos;
    input[0].setSelectionRange(caret_pos, caret_pos);
  };

  _helpers.formatPhoneNumber = function (input) {
    let phoneInput = window.intlTelInput(input, {
      initialCountry: _helpers.guessedCountry.slice(0, 2),
      onlyCountries: ["us", "au", "ca"],
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
    });
    return phoneInput.getNumber();
  };

  _helpers.logoSlider = function (elem, numSlides = 3, speed = 4000) {
    var slider = $(elem).find(".logo-slider-inner"),
      sliderNav = slider.closest(".logo-slider").find(".logo-slider-nav"),
      paused = false,
      slideWidth,
      sliderW,
      sliderL;
    $(window)
      .resize(function () {
        numSlides =
          $(window).width() <= 575
            ? 1
            : $(window).width() <= 767
              ? 2
              : $(window).width() <= 991
                ? 3
                : numSlides;
        slideWidth = 100 / numSlides;
        slider.find(".logo-slide").css("min-width", slideWidth + "%");
        sliderW = slider[0].scrollWidth;
        sliderL = slider.children(".logo-slide").length;
      })
      .resize();

    let slide = 0;
    const startSlider = () => {
      if (slide >= sliderL - (numSlides - 1)) {
        slide = 0;
      }
      slider.find(".logo-slide").css({
        transform: "translateX(-" + (sliderW / sliderL) * slide + "px)",
      });
      slide++;
    };

    const sliderControls = function (fn, t) {
      var sliderInterval = setInterval(fn, t);

      this.stop = function () {
        if (sliderInterval) {
          clearInterval(sliderInterval);
          sliderInterval = null;
        }
        return this;
      };

      this.start = function () {
        if (!sliderInterval) {
          this.stop();
          sliderInterval = setInterval(fn, t);
        }
        return this;
      };
    };

    var sliderControl = new sliderControls(startSlider, speed);

    slider.closest(".logo-slider").hover(
      function () {
        sliderControl.stop();
      },
      function () {
        if (!paused) {
          sliderControl.start();
        }
      },
    );

    sliderNav.find(".logo-sliderPause").click(function () {
      if (!sliderNav.find(".pause").hasClass("d-none")) {
        paused = true;
        sliderNav.find(".pause").addClass("d-none");
        sliderNav.find(".play").removeClass("d-none");
        sliderControl.stop();
      } else {
        paused = false;
        sliderNav.find(".pause").removeClass("d-none");
        sliderNav.find(".play").addClass("d-none");
        sliderControl.start();
      }
    });

    sliderNav.find(".logo-slider-arrow_Left").click(function () {
      slide = slide - 2 <= 0 ? sliderL - numSlides : slide - 2;
      slider.find(".logo-slide").css({
        transform: "translateX(-" + (sliderW / sliderL) * slide + "px)",
      });
    });

    sliderNav.find(".logo-slider-arrow_Right").click(function () {
      slide = slide + 1 >= sliderL - (numSlides - 1) ? 0 : slide + 1;
      slider.find(".logo-slide").css({
        transform: "translateX(-" + (sliderW / sliderL) * slide + "px)",
      });
    });
  };

  _helpers.testimonialSlider = function (elem, numSlides = 5, speed = 7000) {
    var slider = $(elem).find(".testimonial-slider-inner"),
      sliderNav = slider
        .closest(".testimonial-slider")
        .find(".testimonial-slider-nav"),
      sliderDots = slider
        .closest(".testimonial-slider")
        .find(".testimonial-dots"),
      sliderLength = slider.find(".testimonial-slide").length,
      slideWidth,
      activePos,
      prevSlideCount,
      nextSlideCount;

    $(window)
      .resize(function () {
        if ($(window).width() <= 660) {
          numSlides = 1;
          prevSlideCount = 0;
          nextSlideCount = 4;
        } else if ($(window).width() <= 1200) {
          numSlides = 3;
          prevSlideCount = 1;
          nextSlideCount = 3;
        } else {
          numSlides = 5;
          prevSlideCount = 2;
          nextSlideCount = 2;
        }
        activePos = Math.ceil((1 + numSlides) / 2) - 1;
        slideWidth = 100 / numSlides;
        slider.find(".testimonial-slide").css("min-width", slideWidth + "%");

        slider
          .find(".testimonial-slide:eq(" + activePos + ")")
          .addClass("active")
          .siblings()
          .removeClass("active");
      })
      .resize();

    for (let index = 0; index < sliderLength; index++) {
      let active = index == 0 ? "active" : "";
      sliderDots.append(
        "<div class='testimonial-dot " +
          active +
          "' data-slide='" +
          index +
          "'><span></span></div>",
      );
    }

    slider.find(".testimonial-slide").each(function () {
      this.setAttribute("draggable", "false");
    });

    let slide = 0;
    const getNext = function (i) {
      slider
        .find(".testimonial-slide.active")
        .next()
        .addClass("active")
        .siblings()
        .removeClass("active");

      if (slider.find(".testimonial-slide.active").next().length == 1) {
        slider.find(".testimonial-slide").first().remove().appendTo(slider);
      }
      let nextDot =
        sliderDots.find(".active").next().length < 1
          ? sliderDots.find(".testimonial-dot").first()
          : sliderDots.find(".active").next();
      sliderDots.find(".active").removeClass("active");
      nextDot.addClass("active");
      slide++;
    };

    const sliderControls = function (fn, t) {
      var sliderInterval = setInterval(fn, t);

      this.start = function () {
        if (!sliderInterval) {
          this.stop();
          sliderInterval = setInterval(fn, t);
        }
        return this;
      };

      this.stop = function () {
        if (sliderInterval) {
          clearInterval(sliderInterval);
          sliderInterval = null;
        }
        return this;
      };

      this.next = function () {
        if (sliderInterval) {
          clearInterval(sliderInterval);
          sliderInterval = null;
          getNext();
          sliderInterval = setInterval(fn, t);
        }
        return this;
      };

      this.prev = function () {
        if (sliderInterval) {
          clearInterval(sliderInterval);
          let previous =
            slider.find(".testimonial-slide.active").prev().length == 0
              ? slider.find(".testimonial-slide").last().prependTo(slider)
              : slider.find(".testimonial-slide.active").prev();
          previous.addClass("active").siblings().removeClass("active");
          if (
            slider.find(".testimonial-slide.active").prev().length == 1 ||
            numSlides == 3
          ) {
            slider.find(".testimonial-slide").last().prependTo(slider);
          }
          let prevDot =
            sliderDots.find(".active").prev().length < 1
              ? sliderDots.find(".testimonial-dot").last()
              : sliderDots.find(".active").prev();
          sliderDots.find(".active").removeClass("active");
          prevDot.addClass("active");
          slide--;
          sliderInterval = setInterval(fn, t);
        }
        return this;
      };

      this.select = function (obj) {
        if (sliderInterval) {
          clearInterval(sliderInterval);
          slider
            .find(".testimonial-slide[data-slide='" + obj.data("slide") + "']")
            .addClass("active")
            .siblings()
            .removeClass("active");
          obj.addClass("active").siblings().removeClass("active");

          var prevSlides = slider.find(".active").prevAll(),
            nextSlides = slider.find(".active").nextAll();
          if (prevSlides.length > prevSlideCount) {
            Array.prototype.reverse
              .call(prevSlides.slice(-(prevSlides.length - prevSlideCount)))
              .appendTo(slider);
          } else if (nextSlides.length > prevSlideCount) {
            Array.prototype.reverse
              .call(nextSlides.slice(-(nextSlides.length - nextSlideCount)))
              .prependTo(slider);
          }
          sliderInterval = setInterval(fn, t);
        }
        return this;
      };
    };

    var sliderControl = new sliderControls(getNext, speed);

    slider.hover(
      function () {
        sliderControl.stop();
      },
      function () {
        sliderControl.start();
      },
    );

    sliderNav.find(".testimonial-slider-control-prev").click(function () {
      sliderControl.prev();
    });

    sliderNav.find(".testimonial-slider-control-next").click(function () {
      sliderControl.next();
    });

    $(document).delegate(".testimonial-dot", "click", function () {
      sliderControl.select($(this));
    });

    slider.bind("mousedown touchstart mousemove touchmove", function (event) {
      event.preventDefault();
    });

    slider
      .find(".testimonial-slide")
      .children()
      .each(function (index) {
        if (
          index != 0 &&
          index != slider.find(".testimonial-slide").children().length - 1
        ) {
          $(this).css("cursor", "grab");
        }
      });

    let THRESHOLD, a, b, x, y, x1, y1, recordedTime;
    const dir = () => {
      ((a = x - x1), (b = y - y1));
      if (!(parseInt(Math.sqrt(a * a + b * b), 10) < THRESHOLD)) {
        if (x1 - x > Math.abs(y - y1)) {
          return "left";
        }
        if (x - x1 > Math.abs(y - y1)) {
          return "right";
        }
        if (y1 - y > Math.abs(x - x1)) {
          return "up";
        }
        if (y - y1 > Math.abs(x - x1)) {
          return "down";
        }
      } else {
        return "none";
      }
    };
    THRESHOLD = 15;
    x = y = x1 = y1 = 0;
    recordedTime = new Date().getTime();
    document.querySelector(".testimonial-slider-inner").addEventListener(
      "touchstart",
      function (a) {
        50 < new Date().getTime() - recordedTime &&
          ((x = parseInt(a.changedTouches[0].pageX, 10)),
          (y = parseInt(a.changedTouches[0].pageY, 10)),
          (recordedTime = new Date().getTime()));
      },
      !1,
    );
    document.querySelector(".testimonial-slider-inner").addEventListener(
      "touchend",
      function (a) {
        x1 = x;
        y1 = y;
        x = parseInt(a.changedTouches[0].pageX, 10);
        y = parseInt(a.changedTouches[0].pageY, 10);
        if (dir() === "right") {
          sliderControl.start();
          sliderControl.prev();
          sliderControl.stop();
        } else if (dir() === "left") {
          sliderControl.start();
          sliderControl.next();
          sliderControl.stop();
        }
        recordedTime = new Date().getTime();
      },
      !1,
    );
    document.querySelector(".testimonial-slider-inner").addEventListener(
      "mousedown",
      function (a) {
        50 < new Date().getTime() - recordedTime &&
          ((x = a.clientX),
          (y = a.clientY),
          (recordedTime = new Date().getTime()));
      },
      !1,
    );
    document.querySelector(".testimonial-slider-inner").addEventListener(
      "mouseup",
      function (a) {
        x1 = x;
        y1 = y;
        x = a.clientX;
        y = a.clientY;
        if (dir() === "right") {
          sliderControl.start();
          sliderControl.prev();
          sliderControl.stop();
        } else if (dir() === "left") {
          sliderControl.start();
          sliderControl.next();
          sliderControl.stop();
        }
        recordedTime = new Date().getTime();
      },
      !1,
    );
  };

  _helpers.submitWithRecaptcha = function (
    form,
    formData,
    formResponse,
    contentType,
  ) {
    contentType =
      contentType == "undefined"
        ? "application/x-www-form-urlencoded"
        : contentType;
    grecaptcha.ready(function () {
      grecaptcha
        .execute(thryvSettings.recaptcha["v3"], {
          action: "submit_with_recaptcha",
        })
        .then(function (token) {
          let data =
            formData +
            "&recaptcha_token=" +
            token +
            "&content_type=" +
            encodeURIComponent(contentType);
          let datastring = data + "&action=submit_with_recaptcha";

          $.ajax({
            type: "POST",
            url: thryvSettings.ajaxurl,
            data: datastring,
            beforeSend: function () {
              form.find(".spinner").show();
            },
            success: function (response) {
              console.log(response);
              form.fadeOut(250, function () {
                form.after('<div class="response">' + formResponse + "</div>");
                form.siblings(".response").fadeIn(200);
              });
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.log(
                Object.entries(jqXHR) +
                  " | " +
                  textStatus +
                  " | " +
                  errorThrown,
              );
            },
          });
        });
    });
  };

  _helpers.submitFormToTray = function (
    form,
    formData,
    hasResponse = false,
    formResponse = "",
    callback = function () {},
  ) {
    console.log(formData);
    grecaptcha.ready(function () {
      console.log(thryvSettings.recaptcha["v3"]);
      grecaptcha
        .execute(thryvSettings.recaptcha["v3"], { action: "send_to_tray_form" })
        .then(function (token) {
          let data =
            formData +
            "&recaptcha_token=" +
            token +
            "&recaptcha_action=download_report_form";
          let datastring = data + "&action=send_to_tray";

          $.ajax({
            type: "POST",
            url: thryvSettings.ajaxurl,
            data: datastring,
            beforeSend: function () {
              form.find(".spinner").addClass("d-inline-block").show();
            },
            success: function (response) {
              if (hasResponse) {
                console.log(response);
                form.fadeOut(250, function () {
                  form.after(
                    '<div class="response">' + formResponse + "</div>",
                  );
                  form.siblings(".response").fadeIn(200);
                });
              }
              callback(response);
            },
            error: function (jqXHR, textStatus, errorThrown) {
              console.log(
                Object.entries(jqXHR) +
                  " | " +
                  textStatus +
                  " | " +
                  errorThrown,
              );
            },
          });
        });
    });
  };

  _helpers.createPDF = function (
    payload,
    endpoint,
    pdfName,
    successFn,
    el = null,
    autoDownload = true,
  ) {
    payload = typeof payload === "object" ? JSON.stringify(payload) : payload;
    $.ajax({
      type: "POST",
      url: thryvSettings.ajaxurl,
      data:
        "&payload=" +
        encodeURIComponent(payload) +
        "&endpoint=" +
        endpoint +
        "&action=create_pdf",
      success: function (response) {
        // console.log(response);
        if (response.success) {
          // convert to response base64 encoding
          var binaryString = window.atob(response.data);
          var binaryLen = binaryString.length;
          var bytes = new Uint8Array(binaryLen);

          for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
          }

          // create a download anchor tag
          var downloadLink =
            el == null
              ? document.createElement("a")
              : document.querySelector(el);
          downloadLink.target = "_blank";
          downloadLink.download = pdfName + ".pdf";

          // convert downloaded data to a Blob
          var blob = new Blob([bytes], {
            type: "application/pdf",
          });

          // create an object URL from the Blob
          var URL = window.URL || window.webkitURL;
          var downloadUrl = URL.createObjectURL(blob);

          // set object URL as the anchor's href
          downloadLink.href = downloadUrl;

          // add element to body if none exists
          if (el == null) {
            document.body.appendChild(downloadLink);
          }

          // fire a click event on the anchor if auto download enabled
          if (autoDownload) {
            downloadLink.click();
          }

          successFn(downloadLink.href);
        } else {
          console.log(response);
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(
          Object.entries(jqXHR) + " | " + textStatus + " | " + errorThrown,
        );
      },
    });
  };

  _helpers.createICS = function (
    eventName,
    startDate,
    endDate,
    eventLocation,
    eventDetails,
    el = null,
    autoDownload = true,
  ) {
    var icsFile = null;
    var link =
      el == null ? document.createElement("a") : document.querySelector(el);
    var currDate = new Date();
    var formatDate = function (date) {
      date = new Date(+date);
      date.setTime(date.getTime() - date.getTimezoneOffset() * 60000);
      let dateAsString = date.toISOString().substr(0, 19);
      return dateAsString.replace(/[^T0-9]/g, "");
    };
    var ics = "BEGIN:VCALENDAR\n";
    ics += "VERSION:2.0\n";
    ics += "PRODID:jquery.icalendar\n";
    ics += "CALSCALE:GREGORIAN\n";
    ics += "METHOD:PUBLISH\n";
    ics += "BEGIN:VEVENT\n";
    ics += "DTEND:" + formatDate(endDate) + "\n";
    ics += "UID:1659555649234@keith-wood.name\n";
    ics += "DTSTAMP:" + formatDate(currDate) + "\n";
    ics += "LOCATION:" + eventLocation + "\n";
    ics += "DESCRIPTION:" + eventDetails + "\n";
    ics += "SUMMARY:" + eventName + "\n";
    ics += "CREATED:" + formatDate(currDate) + "\n";
    ics += "DTSTART:" + formatDate(startDate) + "\n";
    ics += "BEGIN:VALARM\n";
    ics += "X-WR-ALARMUID:72A5D95F-F4A2-4151-850E-79F300628ECD\n";
    ics += "TRIGGER:-PT15M\n";
    ics += "ATTACH;VALUE=URI:Chord\n";
    ics += "ACTION:AUDIO\n";
    ics += "END:VALARM\n";
    ics += "END:VEVENT\n";
    ics += "END:VCALENDAR\n";

    var data = new File([ics], { type: "text/calendar" });
    if (icsFile !== null) {
      window.URL.revokeObjectURL(icsFile);
    }
    icsFile = window.URL.createObjectURL(data);

    link.href = icsFile;
    link.download = eventName + ".ics";

    if (autoDownload) {
      link.click();
    }
  };

  _helpers.twilioVerifyFn = function (
    to,
    channel,
    callback = function () {
      console.log("callback");
    },
    locale = "en",
  ) {
    this.args = {
      to: to,
      channel: channel,
      callback,
      locale: locale,
      verfication_code: null,
      phone: null,
    };

    this.fetchData = function (method, options) {
      let $this = this;
      let lookupParam = method === "lookup" ? "&types=carrier" : "";
      let datastring =
        new URLSearchParams($this.args).toString() +
        "&endpoint=" +
        thryvSettings.twilioAPI +
        method +
        lookupParam +
        "&action=twilioVerify";
      $.ajax({
        type: "POST",
        url: thryvSettings.ajaxurl,
        data: datastring,
        beforeSend: function () {
          // console.log(datastring);
        },
        success: function (response) {
          // console.log(response);
          let status = response?.data?.success ? "success" : "error";
          if (method == "lookup" && response?.success) {
            status = response.data?.carrier?.type
              ? (response?.data?.carrier?.type === "mobile" &&
                  options["mobileOnly"] === true) ||
                (response?.data?.carrier?.type !== "voip" &&
                  options["mobileOnly"] === false)
                ? "success"
                : "error"
              : "success";
          }
          $this.args.callback(status, response);
        },
        error: function (response) {
          // console.log(response);
          $this.args.callback("fatal", response);
        },
      });
    };

    this.start = function () {
      this.addArgs(arguments);
      this.fetchData("start-verify");
      _helpers.setThryvCookie("twilio_verify", JSON.stringify(this.args), 0.01);
    };

    this.confirm = function (to, verification_code, callback) {
      this.addArgs(arguments, ["to", "verification_code", "callback"]);
      this.fetchData("check-verify");
    };

    this.lookup = function (phone, callback, mobileOnly = true) {
      this.addArgs(arguments, ["phone", "callback", "mobileOnly"]);
      this.fetchData("lookup", { mobileOnly: mobileOnly });
    };

    this.cancel = function (to, callback) {
      this.addArgs(arguments, ["to", "callback"]);
      this.fetchData("update-verify");
    };

    this.addArgs = function (array, specific_keys = false) {
      let $this = this;
      if (_helpers.Cookie.get("twilio_verify")) {
        Object.entries(JSON.parse(_helpers.Cookie.get("twilio_verify"))).map(
          (entry) => {
            $this.args[entry[0]] = entry[1];
          },
        );
      }
      if (specific_keys) {
        let i = 0;
        specific_keys.map((key) => {
          if (array[i] != "") {
            $this.args[key] = array[i];
          }
          i++;
        });
      } else {
        let i;
        for (i = 0; i < array.length; ++i) {
          let key = Object.keys($this.args)[i];
          $this.args[key] = array[i];
        }
      }
      return this;
    };
  };
  _helpers.twilioVerify = new _helpers.twilioVerifyFn();

  /**
   * Optimizely helper functions
   * @type {Object}
   */
  _helpers.Optimizely = {};

  _helpers.Optimizely.getActiveExperimentIds = function () {
    var activeExperiment = [];

    if (
      typeof optimizely === "object" &&
      typeof optimizely.get === "function"
    ) {
      activeExperiment = optimizely.get("state").getActiveExperimentIds();
    }

    return activeExperiment;
  };

  /**
   * Heap helper functions
   * @type {Object}
   */
  _helpers.Heap = {};

  _helpers.Heap.get = function (name = false) {
    if (typeof heap === "undefined") return;

    if (!name) return heap;

    if (heap.hasOwnProperty(name)) return heap[name];

    return null;
  };

  /**
   * helper function to get URL parameters. Can
   * also be used to retrieve hash parameters from URL
   *
   * @param {String} name name of the param
   * @param {String} type Either url or hash
   * @return {mixed}
   */
  _helpers.getUrlParam = function (name = false, type = "url") {
    var urlParamsStr = window.location.search;
    var hashParamsStr = window.location.hash.replace("#", "");
    var params =
      type == "url"
        ? new URLSearchParams(urlParamsStr)
        : new URLSearchParams(hashParamsStr);

    return name ? params.get(name) : Object.fromEntries(params);
  };

  /**
   * Map URL parameters with form fields. Add the mapping on
   * the field in data-param attribute. i.e, data-param="{PARAM_NAME}" keep
   * in mind to use the curly brackets ({}) to wrap the PARAM_NAME
   *
   * @param  {Object} fields jQuery element
   * @return {void}
   */
  _helpers.mapUrlParams = function (fields) {
    fields.each(function (index, el) {
      var $el = jQuery(el);
      var str = $el.attr("data-param");
      var matches = str.match(/\{([^}]+)\}/g)
        ? [...str.match(/\{([^}]+)\}/g)]
        : [];

      jQuery.map(matches, function (item, index) {
        var p = helpers.getUrlParam(item.replace("{", "").replace("}", ""));
        p = p ? p : "";
        $el.attr("data-param", $el.attr("data-param").replace(item, p));
      });

      $el.val(jQuery.trim($el.attr("data-param")));
    });
  };

  _helpers.previewFile = function (input, img, callback) {
    const preview = img instanceof jQuery ? img[0] : img;
    const fileObj = input instanceof jQuery ? input[0] : input;
    const file = fileObj.files?.length > 0 ? fileObj.files[0] : false;
    const reader = new FileReader();

    if (file) {
      reader.addEventListener(
        "load",
        () => {
          // convert image file to base64 string
          preview.src = reader.result;
        },
        false,
      );
      reader.readAsDataURL(file);
      preview.style.display = "block";
      callback();
    }
  };

  _helpers.matchHeight = function (wrapper, selector) {
    // Select and loop the container element of the elements you want to equalise
    $(wrapper).each(function () {
      // Cache the highest
      var highestBox = 0;

      // Select and loop the elements you want to equalise
      $(selector, this).each(function () {
        $(this).css("height", "auto");
        // If this box is higher than the cached highest then store it
        if ($(this).outerHeight() > highestBox) {
          highestBox = $(this).outerHeight();
        }
      });

      // Set the height of all those children to whichever was highest
      $(selector, this).outerHeight(highestBox);
    });
  };

  /**
   * Download a file using the anchor tag's download attribute
   * @param  String         file File URL
   * @param  String|Boolean name Name of the file URL
   * @return Void
   */
  _helpers.downloadFile = function (file, name = false) {
    // Create a link and set the download URL
    var elLink = document.createElement("a");

    elLink.style.display = "none";
    elLink.href = file;
    elLink.download = name ? name : file.split("/").reverse()[0]; // file basename

    // It needs to be added to the DOM so it can be clicked
    document.body.appendChild(elLink);

    elLink.click();

    // To make this work on Firefox we need to wait
    // a little while before removing it.
    setTimeout(() => {
      elLink.parentNode.removeChild(elLink);
    }, 0);
  };

  _helpers.addImageToMedia = function (form, callback) {
    // can be form data or element name
    let form_data =
      typeof form === "object"
        ? form
        : new FormData(document.querySelector(form));
    $.ajax({
      type: "POST",
      url: thryvSettings.ajaxurl + "?action=add_image_to_media",
      data: form_data,
      processData: false,
      contentType: false,
    })
      .done(function (response) {
        console.log("addImageToMedia Success:", response);
        let filename = response["data"]["file"];
        let link = window.location.origin + "/tmp_imgs/" + filename;
        callback(link, filename);
      })
      .fail(function (response) {
        console.log(`addImageToMedia Error: ${response}`);
      });
  };

  _helpers.removeImageFromMedia = function (
    filename,
    callback = function () {},
  ) {
    $.ajax({
      type: "POST",
      url: thryvSettings.ajaxurl,
      data: "action=remove_image_from_media&filename=" + filename,
      success: function (response) {
        // console.log(response);
        callback();
      },
      error: function (response) {
        console.log(response);
      },
    });
  };

  /**
   * helper function to redirect to a url with the all the current URL params
   *
   * @param string  url
   * @param object  params
   * @param boolean dontCarryParams
   * @param array   excludeParams
   *
   * usage:
   *   helpers.redirect('http://example.com', {param1: 111, param2: 222})
   *   will redirect to http://example.com/?param1=111&param2=222
   *
   */
  _helpers.redirect = function (
    url,
    params = {},
    dontCarryParams = false,
    excludeParams = [],
  ) {
    params = typeof params === "object" ? params : {};
    params = dontCarryParams === true ? {} : params;

    var currentParams = Object.fromEntries(
      new URLSearchParams(window.location.search),
    );

    for (var i = 0; i < excludeParams.length; i++) {
      if (currentParams.hasOwnProperty(excludeParams[i])) {
        delete currentParams[excludeParams[i]];
      }
    }

    var allParams = new URLSearchParams({ ...currentParams, ...params });
    var allParamsStr = allParams.toString();
    var redirectUrl = url;

    redirectUrl += allParamsStr ? (url.includes("?") ? "&" : "?") : "";
    redirectUrl += allParams.toString();

    // console.log('redirectUrl', redirectUrl);

    window.location = redirectUrl;
  };

  _helpers.getInitFormData = (country = thryvSettings.thryvCountry) => {
    let initFormData = [];
    // Define Form Variables Based on location
    switch (country) {
      case "AU":
        initFormData["websiteURL"] = "https://www.example.com.au";
        initFormData["cityLabel"] = "City/Suburb";
        initFormData["countryCode"] = "AU";
        initFormData["phoneNumMinMax"] = 12;
        initFormData["phonePlaceholder"] = "8888 888 888";
        initFormData["phoneNumPattern"] = "^[0-9]{4}.[0-9]{3}.[0-9]{3}$";
        initFormData["stateLabel"] = "State";
        initFormData["states"] = [
          "NSW",
          "NT",
          "QLD",
          "SA",
          "TAS",
          "VI",
          "WA",
          "ACT",
        ];
        initFormData["stateMin"] = 2;
        initFormData["stateMax"] = 3;
        initFormData["zipLabel"] = "Postcode";
        initFormData["zipMinMax"] = 4;
        initFormData["zipPlaceholder"] = "0000";
        break;
      case "CA":
        initFormData["websiteURL"] = "https://www.example.ca";
        initFormData["cityLabel"] = "City";
        initFormData["countryCode"] = "CA";
        initFormData["phoneNumMinMax"] = 14;
        initFormData["phonePlaceholder"] = "(555) 123-4567";
        initFormData["phoneNumPattern"] = "^D?(d{3})D?D?(d{3})D?(d{4})$";
        initFormData["stateLabel"] = "Province";
        initFormData["states"] = [
          "AB",
          "BC",
          "MB",
          "NB",
          "NL",
          "NS",
          "NT",
          "NU",
          "ON",
          "PE",
          "QC",
          "SK",
          "YT",
        ];
        initFormData["stateMin"] = 2;
        initFormData["stateMax"] = 2;
        initFormData["zipLabel"] = "Postal Code";
        initFormData["zipMinMax"] = 7;
        initFormData["zipPlaceholder"] = "A1A 1A1";
        break;
      default:
        initFormData["websiteURL"] = "https://www.example.com";
        initFormData["cityLabel"] = "City";
        initFormData["countryCode"] = "US";
        initFormData["phoneNumMinMax"] = 14;
        initFormData["phonePlaceholder"] = "(555) 123-4567";
        initFormData["phoneNumPattern"] = "^D?(d{3})D?D?(d{3})D?(d{4})$";
        initFormData["stateLabel"] = "State";
        initFormData["states"] = [
          "AL",
          "AK",
          "AZ",
          "AR",
          "CA",
          "CO",
          "CT",
          "DE",
          "DC",
          "FL",
          "GA",
          "HI",
          "ID",
          "IL",
          "IN",
          "IA",
          "KS",
          "KY",
          "LA",
          "ME",
          "MD",
          "MA",
          "MI",
          "MN",
          "MS",
          "MO",
          "MT",
          "NE",
          "NV",
          "NH",
          "NJ",
          "NM",
          "NY",
          "NC",
          "ND",
          "OH",
          "OK",
          "OR",
          "PA",
          "RI",
          "SC",
          "SD",
          "TN",
          "TX",
          "UT",
          "VT",
          "VA",
          "WA",
          "WV",
          "WI",
          "WY",
        ];
        initFormData["stateMin"] = 2;
        initFormData["stateMax"] = 2;
        initFormData["zipLabel"] = "Zip";
        initFormData["zipMinMax"] = 5;
        initFormData["zipPlaceholder"] = "00000";
    }

    return initFormData;
  };

  _helpers.onDOMEntry = (el, callback) => {
    var observer = new MutationObserver(function (mutations) {
      if ($(el).length > 0) {
        // console.log("Is in the DOM: " + "\n" + $(el)[0]);
        callback();
        observer.disconnect();
      }
    });
    observer.observe(document, {
      attributes: false,
      childList: true,
      characterData: false,
      subtree: true,
    });
  };

  /**
   * Render invisible captcha V2 to an element
   * @param  String|Object recaptchaContainer Container element object or the selector string
   * @param  Function      verifyCallback     Callback function
   * @return Void
   */
  _helpers.renderInvisibleCaptchaV2 = function (
    recaptchaContainer,
    verifyCallback,
  ) {
    var $ = jQuery;
    var parameters, widgetId;

    var appendCaptchaElemCB = function () {
      if (!(recaptchaContainer instanceof jQuery)) {
        recaptchaContainer = $(recaptchaContainer);
      }

      recaptchaContainer.empty();
      recaptchaContainer.append(
        '<div class="g-recaptcha" data-size="invisible"></div>',
      );

      recaptchaContainer = recaptchaContainer.find(".g-recaptcha").get(0);
    };

    var renderCaptchaCB = function () {
      appendCaptchaElemCB();

      grecaptcha.ready(function () {
        parameters = {
          sitekey: thryvData.recaptcha.invisible_v2_site_key,
          callback: verifyCallback,
          isolated: true,
        };

        widgetId = grecaptcha.render(recaptchaContainer, parameters);

        grecaptcha.execute(widgetId);
      });
    };

    renderCaptchaCB();
  };

  /**
   * Enqueue scripts dynamically into DOM.
   * Example usage
   *
   * helpers.enqueueScript({
   *   'html2canvas': {
   *     id: 'html2canvas',
   *     url: 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js',
   *     onload: () => {
   *       // code
   *     },
   *   },
   *   'FileSaver': {
   *     id: 'FileSaver',
   *     url: 'https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.5/FileSaver.min.js',
   *   },
   * }, () => {
   *
   *     // code
   *
   * });
   *
   * @param  Object  scripts  [Scripts object]
   * @param  Boolean callback [Callback function to call after all the scripts are loaded]
   * @return Void
   */
  _helpers.enqueueScript = function (scripts, callback = false) {
    var key,
      key2,
      script,
      scriptId,
      scriptUrl,
      scriptElem,
      scriptExists,
      scriptsLength,
      scriptsLoaded,
      scriptAttributes;

    scriptsLoaded = scriptsLength = 0;

    for (key in scripts) {
      scriptsLength++;
    }

    for (key in scripts) {
      if (typeof scripts[key].id === "undefined") scripts[key].id = key;

      script = scripts[key];
      scriptId = script.id;
      scriptUrl = script.url;
      scriptAttributes =
        typeof script.attributes === "undefined" ? {} : script.attributes;
      scriptExists = document.querySelector("script#" + scriptId);

      if (!scriptExists) {
        scriptElem = document.createElement("script");
        scriptElem.src = scriptUrl;
        scriptElem.type = "text/javascript";
        scriptElem.id = scriptId;

        for (key2 in scriptAttributes) {
          // scriptElem[key2] = scriptAttributes[key2];
          scriptElem.setAttribute(key2, scriptAttributes[key2]);
        }

        if (document.head) {
          document.head.appendChild(scriptElem);
        } else if (document.body) {
          document.body.appendChild(scriptElem);
        } else {
          return; // no place to add the script
        }

        scriptElem.onload = function (script) {
          script = scripts[script.target.getAttribute("id")];
          scriptsLoaded++;

          if (typeof script.onload === "function") {
            script.onload();
          }
        };

        /**
         * Callback function to run after script is loaded
         */
      } else if (scriptExists && typeof script.onload === "function") {
        script.onload();
        scriptsLoaded++;
      } else if (scriptExists && typeof script.onload === "undefined") {
        scriptsLoaded++;
      }
    }

    if (typeof callback === "function") {
      var interval = setInterval(function () {
        if (scriptsLength === scriptsLoaded) {
          callback();
          clearInterval(interval);
        }
      }, 100);
    }
  };

  _helpers.enqueueStyle = function (styles) {
    var key,
      key2,
      style,
      styleId,
      styleUrl,
      styleMedia,
      styleElem,
      styleExists,
      stylesLength,
      stylesLoaded,
      styleAttributes;

    for (key in styles) {
      if (typeof styles[key].id === "undefined") {
        styles[key].id = key;
      }

      style = styles[key];
      styleId = style.id;
      styleUrl = style.url;
      styleAttributes =
        typeof style.attributes === "undefined" ? {} : style.attributes;
      styleExists = document.querySelector("link#" + styleId);

      if (!styleExists) {
        styleElem = document.createElement("link");
        styleElem.id = styleId;
        styleElem.rel = "stylesheet";
        styleElem.type = "text/css";
        styleElem.media = "all";
        styleElem.href = styleUrl;

        for (key2 in styleAttributes) {
          styleElem[key2] = styleAttributes[key2];
        }

        if (document.head) {
          document.head.appendChild(styleElem);
        } else if (document.body) {
          document.body.appendChild(styleElem);
        } else {
          return; // no place to add the style
        }
      }
    }
  };

  /**
   * Will be moving to the dispatchEvent helper instead of this (dispatchAnEvent) to normalize helpers in hubspot pages
   *
   *
   *
   * Dispatch an event using CustomEvent, that can
   * be listened to using addEventListener() method
   *
   * Example usage:
   *
   *   helpers.dispatchAnEvent('my-custom-event', {data: 'The data'})
   *
   *   window.addEventListener('my-custom-event', function(event) {
   *
   *     var data = event.detail.data;
   *
   *     console.log('data', data);
   *
   *   });
   *
   * @param  string eventName Name of the event
   * @param  object detail    Data to send in the event
   * @param  object element   Element object to attach the event to
   * @return void
   */
  _helpers.dispatchAnEvent = function (
    eventName,
    detail = {},
    element = document,
  ) {
    var CustomEventObject = new CustomEvent(eventName, {
      detail: detail,
    });

    element.dispatchEvent(CustomEventObject);
  };

  /**
   * Dispatch an event using CustomEvent, that can
   * be listened to using addEventListener() method
   *
   * Example usage:
   *
   *   helpers.dispatchEvent('my-custom-event', {data: 'The data'})
   *
   *   window.addEventListener('my-custom-event', function(event) {
   *
   *     var data = event.detail.data;
   *
   *     console.log('data', data);
   *
   *   });
   *
   * @param  string eventName Name of the event
   * @param  object detail    Data to send in the event
   * @param  object element   Element object to attach the event to
   * @return void
   */
  _helpers.dispatchEvent = function (
    eventName,
    detail = {},
    element = document,
  ) {
    var CustomEventObject = new CustomEvent(eventName, {
      detail: detail,
    });

    element.dispatchEvent(CustomEventObject);
  };

  /**
   * Will be moving to the listenEvent helper instead of this (listenToEvent) to normalize helpers in hubspot pages
   *
   *
   * Listen to event
   * @param  {string}   eventName
   * @param  {Function} callback
   * @param  {Element}  element
   * @return {void}
   */
  _helpers.listenToEvent = function (eventName, callback, element = document) {
    // Ensure the element exists and callback is a function
    if (element && typeof callback === "function") {
      element.addEventListener(eventName, function (event) {
        callback(event.detail, event);
      });
    }
  };

  /**
   * Listen to event
   * @param  {string}   eventName
   * @param  {Function} callback
   * @param  {Element}  element
   * @return {void}
   */
  _helpers.listenEvent = function (eventName, callback, element = document) {
    // Ensure the element exists and callback is a function
    if (element && typeof callback === "function") {
      element.addEventListener(eventName, function (event) {
        callback(event.detail, event);
      });
    }
  };

  /**
   * Return if a page is rendered inside an iframe
   *
   * @return boolean
   */
  _helpers.insideIframe = function () {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  };

  /**
   * Set an interval for x seconds and clear it after x seconds
   *
   * Example usage:
   *
   *   helpers.clearIntervalAfter(function() {
   *     console.log('run callback!');
   *   })
   *
   * @param  function  callback
   * @param  integer   timeoutDelay
   * @param  integer   intervalDelay
   * @return integer
   */
  _helpers.clearIntervalAfter = function (
    callback,
    timeoutDelay = 5000,
    intervalDelay = 500,
  ) {
    var intervalID = setInterval(callback, intervalDelay);

    setTimeout(function () {
      clearInterval(intervalID);
    }, timeoutDelay);

    return intervalID;
  };

  /**
   * A helper function to keep trying to execute a callback for
   * timeoutDelay milliseconds based on a supplied condition.
   *
   * A use-case is when scripts delayed execution is enabled and the
   * script don't yet have access to the callback that needs to run
   *
   * Example usage:
   *
   *   helpers.execWhen(typeof Enqueues === 'object', function() {
   *     console.log('exec now!');
   *   });
   *
   *
   * @param  string   condition     The eval string or the callback function that should always return boolean
   * @param  function callback      The callback function to execute
   * @param  integer  timeoutDelay  Milliseconds to timeout
   * @param  integer  intervalDelay Milliseconds to timeout
   * @return void
   */
  _helpers.execWhen = function (
    condition,
    callback,
    timeoutDelay = 5000,
    intervalDelay = 200,
  ) {
    if (
      (typeof condition !== "string" && typeof condition !== "function") ||
      typeof callback !== "function"
    ) {
      return;
    }

    var conditionResult;
    var intervalID = helpers.clearIntervalAfter(
      function () {
        try {
          conditionResult =
            typeof condition === "function" ? condition() : eval(condition);

          if (typeof conditionResult !== "boolean") {
            clearInterval(intervalID);
            return;
          }

          if (conditionResult === true) {
            callback();
            clearInterval(intervalID);
          }
        } catch (error) {
          clearInterval(intervalID);
          console.error("Error evaluating condition:", error);
        }
      },
      timeoutDelay,
      intervalDelay,
    );
  };

  /**
   * A helper function to check if intercom is ready
   * @return boolean
   */
  _helpers.isIntercomReady = function () {
    var intercomReady = false;

    // The window.Intercom stub (and even Intercom.booted === true) can
    // exist while the messenger is actually DEAD: `booted` is set
    // before Intercom's /messenger/web/ping — which 403s when consent
    // blocked it or the domain isn't on Intercom's allowlist ("This
    // domain is not allowed for the Intercom Messenger", e.g. on
    // thryv2.test). The only trustworthy evidence the messenger can
    // open is Intercom's own rendered DOM. Without this check the
    // custom Thryver launcher shows as a dead button.
    if (
      typeof window.Intercom === "function" &&
      document.querySelector(
        '#intercom-container, .intercom-lightweight-app, iframe[name*="intercom"]',
      )
    ) {
      intercomReady = true;
    }

    return intercomReady;
  };

  _helpers.psPartnerLookup = function (partnerKey) {
    var result = false;
    $.ajax({
      type: "POST",
      url: thryvSettings.ajaxurl,
      async: false,
      data: "&partner_key=" + partnerKey + "&action=psPartnerLookup",
      success: function (psresponse) {
        result = psresponse.data?.data;
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(
          Object.entries(jqXHR) + " | " + textStatus + " | " + errorThrown,
        );
      },
    });
    return result;
  };

  _helpers.parseUrl = function (url) {
    var urlParsed = {};

    try {
      if (!url.match(/^[a-zA-Z]+:\/\//)) {
        url = thryvData.site_url + (url.startsWith("/") ? "" : "/") + url;
      }

      var url2 = new URL(url);

      urlParsed = {
        protocol: url2.protocol,
        host: url2.host,
        hostname: url2.hostname,
        pathname: url2.pathname,
        hash: url2.hash,
        params: url2.search,
        params_parsed: Object.fromEntries(new URLSearchParams(url2.search)),
      };

      return urlParsed;
    } catch (e) {
      console.log("helpers.parseUrl Err:", e);

      return urlParsed;
    }
  };

  /**
   * Filter array. Trim and unique items
   *
   * @param  Array arr
   * @return Array
   */
  _helpers.filterArray = function (arr) {
    var $ = jQuery;
    var uniqueArr = [];

    $.each(arr, function (i, el) {
      el = $.trim(el);

      if ($.inArray(el, uniqueArr) === -1) {
        uniqueArr.push(el);
      }
    });

    return uniqueArr;
  };

  /**
   * Tag elements with the ga event name.
   * Helpful with adding new GA events from tag-manager (GTM) tags.
   *
   * @param  string elems   jQuery elements selector
   * @param  string evtName Name of the event
   * @return void
   */
  _helpers.tagWithGaEvent = function (elems, evtName) {
    var $ = jQuery;

    // tag elements with the event name
    $(document)
      .find(elems)
      .each(function (index, el) {
        var evtAttr = $(el).attr("data-evt");
        var evts = evtAttr ? evtAttr.split(",") : [];

        evts.push(evtName);

        $(el).attr("data-evt", helpers.filterArray(evts).join(","));
      });
  };

  _helpers.sendToTray = function (data, endpoint, callback = function () {}) {
    data =
      typeof data === "string"
        ? data
        : encodeURIComponent(JSON.stringify(data));
    endpoint = "&endpoint=" + endpoint;
    let datastring = data + endpoint + "&skip_recaptcha=1&action=send_to_tray";
    console.log(datastring);
    $.ajax({
      type: "POST",
      url: thryvSettings.ajaxurl,
      data: datastring,
      success: function (response) {
        console.log(response);
        callback();
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log(
          Object.entries(jqXHR) + " | " + textStatus + " | " + errorThrown,
        );
      },
    });
  };

  _helpers.stringToSlug = function (str) {
    str = str.replace(/^\s+|\s+$/g, ""); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñçěščřžýúůďťň·/_,:;";
    var to = "aaaaeeeeiiiioooouuuuncescrzyuudtn------";

    for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    }

    str = str
      .replace(".", "-") // replace a dot by a dash
      .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
      .replace(/\s+/g, "-") // collapse whitespace and replace by a dash
      .replace(/-+/g, "-") // collapse dashes
      .replace(/\//g, ""); // collapse all forward-slashes

    return str;
  };

  _helpers.formatABN = function (value, elem) {
    var abnID = new String(value);
    elem = $(elem);

    abnID = abnID.substring(0, 14);

    if (abnID.match("[0-9]{2}.[0-9]{3}.[0-9]{3}.[0-9]{3}") == null) {
      var i;
      var abnNumeric = (abnChar = "");
      for (i = 0; i < abnID.length; i++) {
        // Go thru what user has entered one character at a time.
        var abnChar = abnID.substr(i, 1);
        if (!isNaN(abnChar) && abnChar != " ")
          abnNumeric = abnNumeric + abnChar;
      }
      abnID = "";
      for (i = 0; i < abnNumeric.length; i++) {
        // If you are on the 3rd digit, put ' ' before that.
        if (i == 2) abnID = abnID + " ";
        // If you are on the 7th digit, insert '-' before that.
        if (i == 6) abnID = abnID + " ";
        // If you are on the 7th digit, insert '-' before that.
        if (i == 10) abnID = abnID + " ";
        // Add the digit to the abnID charatcer string you are building.
        abnID = abnID + abnNumeric.substr(i, 1);
      }
    } else {
      abnID =
        abnID.substring(0, 2) +
        " " +
        abnID.substring(3, 6) +
        " " +
        abnID.substring(7, 10) +
        " " +
        abnID.substring(11, 14);
    }
    if (abnID != inputVal) inputVal = abnID;
    elem.val(inputVal);
  };

  _helpers.hsPrivacyConsentInit = function (
    $form,
    type = "short",
    linkColor = "thryvcornflower",
    formType = false,
  ) {
    // Check if label exists
    var checkLabel = $form
      .find(".legal-consent-container")
      .find(".hs-form-booleancheckbox-display")
      .find("p");
    checkLabel =
      checkLabel.length <= 0
        ? $form
            .find(".legal-consent-container")
            .find(".hs-form-booleancheckbox-display")
            .find("span")
        : checkLabel;

    // Setup links
    var linkTagOpen = `<a href="#privacy-tooltip" rel="noopener"><u class="${linkColor} underline">`;
    var linkTagClose = `</u>${type === "short" ? " ⓘ" : ""}</a>`;

    var termsLinkTagOpen = `<a href="/terms-of-use" target="_blank"><u class="${linkColor} underline">`;
    var termsLinkTagClose = `</u>${type === "short" ? " ⓘ" : ""}</a>`;

    var privacyLinkTagOpen = `<a href="/privacy-policy" target="_blank"><u class="${linkColor} underline">`;
    var privacyLinkTagClose = `</u>${type === "short" ? " ⓘ" : ""}</a>`;

    // Setup text based on requested type
    var consentText =
      type === "short"
        ? `By checking, I agree to the ${linkTagOpen}privacy statement${linkTagClose}`
        : type === "txt-optin" && formType && formType === "demo"
          ? `By clicking one of the buttons below to request a demo, you agree to Thryv's ${termsLinkTagOpen}Terms of Use</a>${termsLinkTagClose} and ${privacyLinkTagOpen}Privacy Policy${privacyLinkTagClose}, and consent to receive marketing emails and calls from Thryv.`
          : type === "txt-optin"
            ? `By submitting this form you agree to Thryv's ${termsLinkTagOpen}Terms of Use</a>${termsLinkTagClose} and ${privacyLinkTagOpen}Privacy Policy${privacyLinkTagClose}, and consent to receive marketing emails and calls from Thryv.`
            : `By clicking this box, you agree to our ${linkTagOpen}Terms of Service${linkTagClose} and ${linkTagOpen}Privacy Policy${linkTagClose}.`;

    if (thryvSettings.thryvCountry === "US" && checkLabel.length > 0) {
      // Check if form type is specified
      if (type === "txt-optin" || (formType && formType === "demo")) {
        checkLabel
          .closest(".hs-form-booleancheckbox")
          .prepend(`<p class="thryv-steel mb-3">${consentText}</p>`);
        checkLabel.html(
          "By checking this box you agree to receive recurring marketing and transactional texts from Thryv at the number provided. Msg/data rates may apply. Text STOP to cancel. Consent is not required to purchase goods or services.",
        );
      } else {
        checkLabel.html(consentText);
      }
      $form.find(".legal-consent-container").find(".hs-richtext").hide();
    }
    $form.find('[href="#privacy-tooltip"]').click(function (e) {
      e.preventDefault();
      if (thryvSettings.thryvCountry === "US") {
        $form
          .find(".legal-consent-container")
          .find(".hs-richtext")
          .slideToggle();
        $form.find(".legal-consent-container").toggleClass("consent-showing");
      }
    });
  };

  _helpers.removeSecondsFromISODate = function (isoDate) {
    const date = new Date(isoDate);
    return date.toISOString().slice(0, 16) + "Z";
  };

  _helpers.qualifiedEventsListener = function (name, data) {
    if ("record_id" in data.field_values && data.field_values.record_id == "") {
      $.ajax({
        type: "POST",
        url: thryvSettings.ajaxurl,
        data:
          "email=" + data["submissionValues"]["email"] + "&action=getHubspotID",
        success: function (response) {
          console.log("hubspot contact id:", response);
          if ("data" in response && response.data != "") {
            var hs_contact_info = JSON.parse(response.data);
            localStorage.setItem("thryv_lead_hubspot", hs_contact_info.id);
          }
        },
      });
    }

    // Set country code for form
    let countryCode = thryvSettings.thryvCountry.slice(0, 2);

    let qualifiedData = {
      meta: {
        extId: data.bot.id,
        source: data.field_values.source,
      },
      scheduledEvent: {
        transactionType: data.field_values.transactiontype,
        id: data.field_values.id,
        startDateTime: _helpers.removeSecondsFromISODate(
          data.field_values.startdatetime,
        ),
        endDateTime: _helpers.removeSecondsFromISODate(
          data.field_values.enddatetime,
        ),
      },
      customer: {
        hsContactId:
          "record_id" in data.field_values && data.field_values.record_id != ""
            ? data.field_values.record_id
            : localStorage.thryv_lead_hubspot + ".0",
        sfPersonId:
          data.field_values?.sfdc_record_id != "undefined"
            ? data.field_values?.sfdc_record_id
            : "00Q5c00000yyLeTEAU",
        businessName: data.field_values.company,
        firstName: data.field_values.name.split(" ")[0],
        lastName: data.field_values.name.split(" ").pop(),
        address: {
          countryCode: countryCode,
        },
        phone: data.field_values.phone_number_input_only,
        email: data.field_values.email,
      },
      demoRepId: data.field_values.demorepid,
    };
    // let endpoint = _helpers.getUrlParam("endpoint") === "CFIT" || _helpers.getUrlParam("endpoint") === "cfit"
    // 	? 'https://cfit-esb.thryv.com/enterprise/eventlistener' : 'https://pm-esb.thryv.com/enterprise/eventlistener';
    let endpoint =
      thryvSettings.env === "staging"
        ? "https://cfit-esb.thryv.com/enterprise/eventlistener"
        : "https://esb.thryv.com/enterprise/eventlistener";
    console.log("tibco send endpoint:", endpoint);
    $.ajax({
      type: "POST",
      url:
        thryvSettings.ajaxurl +
        "?action=send_qualified_data&endpoint=" +
        endpoint,
      data: qualifiedData,
      success: function (response) {
        console.log(response);
      },
      error: function (response) {
        console.log(response);
      },
    });
  };

  _helpers.throttle = function (func, delay) {
    var lastCall = 0;

    return function (...args) {
      var now = new Date().getTime();

      if (now - lastCall < delay) {
        return;
      }

      lastCall = now;

      func(...args);
    };
  };

  _helpers.getCurrentUrl = function (pathOnly = false, parsed = false) {
    var schema = window.location.protocol;
    var host = window.location.host;
    var uriClean = window.location.pathname;

    if (pathOnly) {
      return uriClean;
    }

    var uriWithParams = uriClean + window.location.search;
    var uriWithParamsHash = uriWithParams + window.location.hash;
    var urlWithParamsHash = `${schema}//${host}${uriWithParamsHash}`;

    if (parsed) {
      return new URL(urlWithParamsHash);
    }

    return urlWithParamsHash;
  };

  _helpers.getCurrentPath = function () {
    return this.getCurrentUrl(true);
  };

  _helpers.splitFullName = function (fullName) {
    // Defensive: callers (e.g. dataLayer pushes from qualified events)
    // may pass undefined when a field isn't present. Return a clean
    // empty shape rather than throwing.
    if (!fullName || typeof fullName !== "string" || fullName.length === 0) {
      return {
        first: "",
        last: "",
      };
    }

    var nameArr = fullName.trim().split(" ");
    var firstname = nameArr[0];
    var lastname = nameArr.splice(1).join(" ");

    return {
      first: firstname,
      last: lastname,
    };
  };

  _helpers.isDomain = function (value) {
    return /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/.test(
      value,
    );
  };

  /**
   * OneTrust helper object to get opted-in groups,
   * opted-out groups and get the cookieName information
   * (i.e, if opted-in, and which group it belongs to etc)
   * @type {Object}
   */
  _helpers.OneTrust = new Object();

  /**
   * Gets all opted-in groups and their cookies
   * @returns {Object} Object containing all opted-in groups and their cookies
   */
  _helpers.OneTrust.optedInGroups = function () {
    var result = {
      groups: {},
      total_groups: 0,
      total_cookies: 0,
    };

    if (!window.ThryvOneTrustGroups) {
      console.warn("ThryvOneTrustGroups not available");
      return result;
    }

    // Loop through all groups
    for (var groupId in window.ThryvOneTrustGroups) {
      var group = window.ThryvOneTrustGroups[groupId];

      // Check if this group is opted-in
      if (group.status === "opted-in") {
        result.total_groups++;
        result.total_cookies += group.cookies_count;

        // Add group info to result
        result.groups[groupId] = {
          name: group.group_name,
          cookie_count: group.cookies_count,
          cookies: {},
        };

        // Add all cookies in this group
        for (var cookieName in group.cookies) {
          result.groups[groupId].cookies[cookieName] = cookieName;
        }
      }
    }

    return result;
  };

  /**
   * Gets all opted-out groups and their cookies
   * @returns {Object} Object containing all opted-out groups and their cookies
   */
  _helpers.OneTrust.optedOutGroups = function () {
    var result = {
      groups: {},
      total_groups: 0,
      total_cookies: 0,
    };

    if (!window.ThryvOneTrustGroups) {
      console.warn("ThryvOneTrustGroups not available");
      return result;
    }

    // Loop through all groups
    for (var groupId in window.ThryvOneTrustGroups) {
      var group = window.ThryvOneTrustGroups[groupId];

      // Check if this group is opted-out
      if (group.status === "opted-out") {
        result.total_groups++;
        result.total_cookies += group.cookies_count;

        // Add group info to result
        result.groups[groupId] = {
          name: group.group_name,
          cookie_count: group.cookies_count,
          cookies: {},
        };

        // Add all cookies in this group
        for (var cookieName in group.cookies) {
          result.groups[groupId].cookies[cookieName] = cookieName;
        }
      }
    }

    return result;
  };

  /**
   * Gets status and group information for a specific cookie
   * @param {string} cookieName - The name of the cookie to look up
   * @returns {Object} - Object containing cookie status and group information
   */
  _helpers.OneTrust.getCookieStatus = function (cookieName) {
    var result = {
      found: false,
      name: cookieName,
      status: "unknown",
      group: {
        id: null,
        name: null,
        cookie_count: 0,
      },
    };

    if (!window.ThryvOneTrustGroups) {
      console.warn("ThryvOneTrustGroups not available");
      return result;
    }

    if (!cookieName) {
      console.warn("Cookie name is required");
      return result;
    }

    // Loop through all groups to find the cookie
    for (var groupId in window.ThryvOneTrustGroups) {
      var group = window.ThryvOneTrustGroups[groupId];

      // Check if this cookie exists in the current group
      if (group.cookies && group.cookies[cookieName]) {
        result.found = true;
        result.status = group.status; // 'opted-in' or 'opted-out'

        // Set group information
        result.group.id = groupId;
        result.group.name = group.group_name;
        result.group.cookie_count = group.cookies_count;

        break; // Exit the loop once cookie is found
      }
    }

    return result;
  };

  /**
   * Translate a string using the translations object
   * @param {string} str - The string to translate
   * @returns {string} - The translated string
   */
  _helpers.translateString = function (str) {
    const translations = window.thryvData.string_translations || {};
    if (!_translationRegexMemo) {
      const escapedKeys = Object.keys(translations).map((key) =>
        key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
      );
      _translationRegexMemo = new RegExp(
        `\\b(${escapedKeys.join("|")})\\b`,
        "g",
      );
    }

    return str.replace(
      _translationRegexMemo,
      (match) => translations[match] || match,
    );
  };

  /**
   * Extended console wrapper with toggleable logging and extra methods.
   *
   * USAGE:
   *   Activate:       helpers.console.activate()
   *   Deactivate:     helpers.console.deactivate()
   *   Check status:   helpers.console.isActive()
   *   Update prefix:  helpers.console.prefix('MyCustomPrefix:')
   *   Reset defaults: helpers.console.reset()
   *
   * @type {Object}
   */
  _helpers.console = new Object();

  _helpers.console = new Object();

  _helpers.console._prefix = "ThryvConsole:";
  _helpers.console._statusKey = "ThryvConsole__status";

  /**
   * Internal helper
   */
  _helpers.console._out = function (method, ...log) {
    if (!this.isActive()) return;

    const c = typeof console !== "undefined" ? console : null;
    if (!c) return;

    const fn = typeof c[method] === "function" ? c[method] : c.log;
    fn.call(c, this._prefix, ...log);
  };

  /**
   * public API
   */
  _helpers.console.activate = function () {
    _helpers.Cookie.set(this._statusKey, "active");
  };

  _helpers.console.prefix = function (prefix) {
    if (typeof prefix === "string" && prefix.length) {
      this._prefix = prefix;
    }
  };

  _helpers.console.deactivate = function () {
    _helpers.Cookie.remove(this._statusKey);
  };

  _helpers.console.isActive = function () {
    return _helpers.Cookie.get(this._statusKey) === "active";
  };

  _helpers.console.reset = function () {
    this.deactivate();
    this._prefix = "ThryvConsole";
  };

  _helpers.console.log = function (...log) {
    this._out("log", ...log);
  };
  _helpers.console.info = function (...log) {
    this._out("info", ...log);
  };
  _helpers.console.warn = function (...log) {
    this._out("warn", ...log);
  };
  _helpers.console.error = function (...log) {
    this._out("error", ...log);
  };
  _helpers.console.debug = function (...log) {
    this._out("debug", ...log);
  };
  _helpers.console.trace = function (...log) {
    this._out("trace", ...log);
  };

  _helpers.console.dir = function (...log) {
    if (!this.isActive() || !console || !console.dir) return;
    if (console.group) console.group(this._prefix);
    log.forEach((arg) => console.dir(arg));
    if (console.groupEnd) console.groupEnd();
  };

  _helpers.console.group = function (label) {
    if (!this.isActive() || !console || !console.group) return;
    console.group(this._prefix, label || "");
  };

  _helpers.console.groupEnd = function () {
    if (!this.isActive() || !console || !console.groupEnd) return;
    console.groupEnd();
  };

  _helpers.console.time = function (label) {
    if (!this.isActive() || !console || !console.time) return;
    console.time(`${this._prefix} ${label}`);
  };

  _helpers.console.timeEnd = function (label) {
    if (!this.isActive() || !console || !console.timeEnd) return;
    console.timeEnd(`${this._prefix} ${label}`);
  };

  /**
   * Returns true if the given debug namespace is enabled.
   *
   * Source: URL `?thryvDebug=<key>[,<key>...]`, promoted to sessionStorage
   * on first call so it stays sticky across page navigations within the
   * same tab. Closing the tab clears it.
   *
   * The `thryvDebug` param name is deliberately distinct from WordPress's
   * `?debug` toggle to avoid collisions.
   *
   * Special tokens:
   *   - `all` / `*` enables every namespace
   *   - `?thryvDebug=off` or `?thryvDebug=clear` wipes the stored set
   *
   * Console API (no reload needed):
   *   helpers.debugOn('ds3')            // enable a namespace
   *   helpers.debugOn('all')            // enable everything
   *   helpers.debugOff('ds3')           // disable one namespace
   *   helpers.debugOff()                // disable all
   *
   * URL API:
   *   ?thryvDebug=qualifiedEvents       // enable for this tab session
   *   ?thryvDebug=ds3,hsForm            // multiple
   *   ?thryvDebug=all                   // everything
   *   ?thryvDebug=off                   // clear
   *
   * @param {string} key
   * @returns {boolean}
   */
  _helpers.shouldDebug = function (key) {
    // Promote URL params to sessionStorage once per page load.
    if (!_helpers.shouldDebug._inited) {
      _helpers.shouldDebug._inited = true;
      try {
        const params = new URLSearchParams(window.location.search);
        if (params.has("thryvDebug")) {
          const raw = (params.get("thryvDebug") || "").trim();
          if (raw === "" || raw === "off" || raw === "clear") {
            sessionStorage.removeItem("thryvDebug");
          } else {
            const stored = (sessionStorage.getItem("thryvDebug") || "")
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean);
            const incoming = raw
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean);
            const merged = Array.from(new Set([...stored, ...incoming]));
            sessionStorage.setItem("thryvDebug", merged.join(","));
          }
        }
      } catch (e) {
        /* sessionStorage may be unavailable (private mode, CSP) — ignore */
      }
    }

    // Sticky session flags
    try {
      const stored = (sessionStorage.getItem("thryvDebug") || "")
        .split(",")
        .map((s) => s.trim());
      if (stored.includes("all") || stored.includes("*")) return true;
      if (stored.includes(key)) return true;
    } catch (e) {
      /* ignore */
    }

    return false;
  };

  /**
   * Enable a debug namespace from the console without reloading.
   * Persists to sessionStorage (sticky per tab).
   *
   *   helpers.debugOn('ds3')
   *   helpers.debugOn('all')
   *
   * @param {string} key
   */
  _helpers.debugOn = function (key) {
    if (!key) return;
    try {
      const stored = (sessionStorage.getItem("thryvDebug") || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      if (!stored.includes(key)) stored.push(key);
      sessionStorage.setItem("thryvDebug", stored.join(","));
      console.log(
        "[Thryv] debug ON:",
        key,
        "— now:",
        stored.join(",") || "(none)",
      );
    } catch (e) {
      console.warn("[Thryv] debugOn failed:", e);
    }
  };

  /**
   * Disable a debug namespace from the console without reloading.
   * Call with no argument to clear all flags.
   *
   *   helpers.debugOff('ds3')
   *   helpers.debugOff()         // wipe all
   *
   * @param {string} [key]
   */
  _helpers.debugOff = function (key) {
    try {
      if (!key) {
        sessionStorage.removeItem("thryvDebug");
        console.log("[Thryv] debug cleared");
        return;
      }
      const stored = (sessionStorage.getItem("thryvDebug") || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
      const filtered = stored.filter((k) => k !== key);
      if (filtered.length) {
        sessionStorage.setItem("thryvDebug", filtered.join(","));
      } else {
        sessionStorage.removeItem("thryvDebug");
      }
      console.log(
        "[Thryv] debug OFF:",
        key,
        "— now:",
        filtered.join(",") || "(none)",
      );
    } catch (e) {
      console.warn("[Thryv] debugOff failed:", e);
    }
  };

  /**
   * Removes keys whose values are null, undefined, or empty string
   * from an object before pushing to the dataLayer.
   * @param {object} obj - The object to sanitize.
   * @returns {object} A shallow copy with empty values removed.
   */
  _helpers.dlSanitize = function (obj) {
    const clean = {};
    Object.keys(obj || {}).forEach((key) => {
      const val = obj[key];
      if (val !== null && val !== undefined && val !== "") {
        clean[key] = val;
      }
    });
    return clean;
  };

  /**
   * Ungates the access to content after a form
   * submission has been completed.
   * @param {string} modalId - The id of the gated form.
   */
  _helpers.grantContentAccess = function (modalId = "#contentGate") {
    _helpers.Cookie.set("gated_content_access", "granted", 1);
    modalId = modalId.includes("#") ? modalId : "#" + modalId;
    $(modalId).modal("hide");
    $(`.gated-link[data-target="${modalId}"]`).each(function () {
      $(this).attr("href", $(this).data("href"));
    });
    $(`[data-target="${modalId}"]`)
      .removeAttr("data-target data-toggle data-href")
      .removeClass("gated-link");

    setTimeout(() => {
      $(
        `.gated-link-trigger[href="${sessionStorage.getItem("gatedLinkTarget")}"]`,
      )[0].click();
    }, 200);
  };
  return _helpers;
})();

// Tealium-driven personalizations removed (May 2026 — Thryv migrated
// from Tealium to GTM). The entire file was one `tealium_enrichment`
// handler reading visitor badges/audiences to decide CTA copy, link
// targets, and Optimizely page activations. Since Tealium was
// decommissioned, the trigger event no longer fires and this code was
// runtime-dead.
//
// If/when audience-driven personalization needs to come back, source
// the signals from GTM dataLayer / cookies / authenticated user state
// rather than utag.data.

// Tealium-driven Optimizely experiment activation removed (May 2026 —
// Tealium decommissioned from this codebase). If A/B activation needs to
// resume, replace the previous `tealium_enrichment` audience trigger with
// a URL/cookie/dataLayer-based check.
